
export default {
    name: 'ContactSuccess',
}
